<template>
  <div id="audio-video-dialogue">
 
    <!-- Loading Animation -->
    <transition name="fade">
      <div class="audio-video-loading-screen" v-if="isLoading">
        <div class="big-symbol-container">
          <div class="flux-animation-circle-one flux-animation-circle"></div>
          <div class="flux-animation-circle-two flux-animation-circle"></div>
          <div class="flux-animation-circle-three flux-animation-circle"></div>
        </div>
      </div>
    </transition> 

    <transition name="fade">
      <TroubleShooting v-if="problemDialogVisible" :toggleProblemDialog="toggleProblemDialog"/>
    </transition>
    
    <transition name="fade">
      <ConnectionTest :toggleConnectionTest="this.toggleConnectionTest" :audioDeviceId="this.audioDeviceId" :videoDeviceId="this.videoDeviceId" :signIn="this.signIn" v-if="ConnectionTestVisible"/>
    </transition>

    <transition name="fade">
      <AudioTest v-if="audioTestDialogVisible" :toggleAudioTestDialogue="toggleAudioTestDialogue"/>
    </transition>

    <div class="audio-video-content">

      <!-- Title -->
      <div class="avd-title">{{ $t('Mikrofon- und Kameraeinstellungen') }}</div>

      <!-- Left Side -->
      <div class="avd-content-left">

        <!-- Camera video stream -->
        <div id="video-container">
          <div class="camera-placeholder" v-if="videoDeviceList.length === 0 || !videoOn || !publisher">
            <img class="user-badge badge" :src="this.localUser.getUserIcon()"/>
            <div id="local-user-badge" class="user-badge-audio badge" :style="{'background-color':getUserColor(this.localUser)}"/>
          </div>
          <FluxComPublisher v-if="(videoDeviceId || audioDeviceId) && !isLoading" v-bind:hidden="!videoOn" id="publisher-container" where="audio-video-dialogue" :opts="publisherAndSubscriberProperties"/>
        </div>

        <!-- Audio test -->
        <md-button @click="toggleAudioTestDialogue()" class="normal-md-button avd-audiotest">{{ $t('Audiotest') }}</md-button>         
      </div>


      <!-- Right Side -->
      <div class="avd-content-right">
        
        <!-- Camera Settings -->
        <div class="settings-section">
          
          <!-- Error Messages -->
          <div class="error-access-denied" v-if="!isLoading">
            <div class="error-access-denied-content" v-if="errors.cameraPermissionDenied">
              {{ $t('Browser-Zugriff auf Ihre Kamera wurde nicht erlaubt. Klicken Sie') }} 
              <span @click="askForPermission()" class="error-access-denied-button">{{ $t('hier')}}</span>
              {{ $t(', um nach dem Zugriff gefragt zu werden.') }} 
            </div>
            <div v-if="videoDeviceList.length === 0 && !errors.cameraPermissionDenied" class="error-access-denied-content">{{ $t('Es wurde keine Kamera erkannt') }}.</div>
          </div>

          <!-- Camera Disable/Enable -->
          <div class="avd-switch-container"> 
            <span class="subheading">{{ $t('Kamera') }}:</span>
            <md-switch class="avd-switch" v-model="videoOn" :disabled="!publisher || !hasVideo"/>
          </div>
        
          <!-- Camera selection -->
          <div>
            <select id="video-selection" :disabled="videoDeviceList.length === 0 || !videoOn" @change="saveDeviceIds();">
              <option v-for="video in videoDeviceList" :value="video.deviceId">{{ getLabelForDevice(video) }}</option>
            </select>
            <md-button class="normal-md-button renew" :disabled="videoDeviceList.length === 0 || !videoOn" @click="updateDeviceLists">
              <Autorenew/>
            </md-button>
          </div>

          <!-- Video settings -->
          <!-- <div class="error-container">
            <div id="video-error" class="error" v-if="videoDeviceList.length === 0">{{ $t('Es wurde keine Kamera erkannt') }}.</div>
          </div>
          <label for="framerate-selection" class="select-label" @mouseenter="tooltips.framerate = true" @mouseleave="tooltips.framerate = false" style="position: relative">Framerate:
            <div class="tooltip" v-if="tooltips.framerate">
              {{ $t('Experimentelles Feature. Bei Schwankungen der Internetgeschwindigkeit kann die Framerate niedriger sein, als Sie sie eingestellt haben.')}}
            </div>
          </label>
          <select id="framerate-selection" :disabled="videoDeviceList.length === 0" @change="setFramerate()">
            <option :value="1">1</option>
            <option :value="7">7</option>
            <option :value="15">15</option>
            <option :value="30" selected>30</option>
          </select> -->
        </div>

          
        <!-- Microphone settings -->
        <div class="settings-section">  
          
          <!-- Error Messages -->
          <div class="error-access-denied" v-if="!isLoading">
            <div class="error-access-denied-content" v-if="errors.microphonePermissionDenied">
              {{ $t('Browser-Zugriff auf Ihr Mikrofon wurde nicht erlaubt. Klicken Sie') }} 
              <span @click="askForPermission()" class="error-access-denied-button">{{ $t('hier')}}</span>
              {{ $t(', um nach dem Zugriff gefragt zu werden.') }} 
            </div>
            <div v-if="videoDeviceList.length === 0 && !errors.microphonePermissionDenied" class="error-access-denied-content">{{ $t('Es wurde keine Mikrofon erkannt') }}.</div>
          </div>

          <!-- Microphone Disable/Enable -->
          <div class="avd-switch-container"> 
            <span class="subheading">{{ $t('Mikrofon') }}:</span>
            <md-switch class="avd-switch" v-model="audioOn" :disabled="!publisher || !hasAudio"/>
          </div>

          <!-- Microphone selection -->
          <div>
            <select id="audio-selection" :disabled="audioDeviceList.length === 0 || !audioOn" @change="saveDeviceIds();">
              <option v-for="audio in audioDeviceList" :value="audio.deviceId">{{ getLabelForDevice(audio) }}</option>
            </select>
            <md-button class="normal-md-button renew" :disabled="audioDeviceList.length === 0 || !audioOn" @click="updateDeviceLists">
              <Autorenew/>
            </md-button>
          </div>
          
          <!-- Audio-Pegel -->
          <meter id="audio-meter" high="1" low="0.2" optimum="0.8" value="0" min="0" max="1"/>

          <!-- Audio settings -->
          <!-- <div class="error-container">
            <div id="audio-error" class="error" v-if="audioDeviceList.length === 0">{{ $t('Es wurde kein Mikrofon erkannt') }}.</div>
          </div>
          <label v-if="!this.$browserDetect.isFirefox" for="bitrate-selection" class="select-label" @mouseenter="tooltips.bitrate = true" @mouseleave="tooltips.bitrate = false" style="position: relative">Bitrate:
            <div class="tooltip" v-if="tooltips.bitrate">
              {{ $t('Experimentelles Feature. Reduzieren Sie die Bitrate bei schlechter Internetverbindung für ein besseres Erlebnis in der Tour.')}}
            </div></label>
          <select v-if="!this.$browserDetect.isFirefox" id="bitrate-selection" :disabled="audioDeviceList.length === 0" @change="setBitrate()">
            <option :value="16000">16000</option>
            <option :value="20000">20000</option>
            <option :value="24000">24000</option>
            <option :value="28000">28000</option>
            <option :value="32000">32000</option>
            <option :value="36000">36000</option>
            <option :value="40000" selected>{{ $t('Standard') }}: 40000</option>
            <option :value="44000">44000</option>
          </select>
          -->
        </div>
      </div>

      <!-- Bottom Bar -->
      <div class="avd-button-container" v-if="from === 'login'">

        <!-- Login button -->
        <md-button @click="saveDeviceIds(); signIn()" class="accent-md-button avd-login-button">
         {{ $t('Jetzt teilnehmen') }}
        </md-button>
        <!-- <md-button class="normal-md-button" @click="signOut()">{{ $t('Zurück') }}</md-button> -->

        <div style="padding-bottom: 20px">
          <!-- Troubleshooting button -->
          <md-button id="problem-button" class="normal-md-button avd-troubleshooting-button" @click="toggleProblemDialog">
            <AlertCircle/>
            <div class="avd-button-text">{{ $t('Problembehandlung') }}</div>
          </md-button>

          <!-- Connection test button -->
          <md-button v-bind:class="{disabled: !videoDeviceId && !audioDeviceId}" id="connection-test-button" class="normal-md-button avd-connectiontest-button" @click="saveDeviceIds(); toggleConnectionTest();">
            <Wifi/>
            <div class="avd-button-text">{{ $t('Verbindungstest') }}</div>
          </md-button>
        </div>

      </div>

    </div>
  </div>
</template>

<script>
import {mapState, mapGetters} from 'vuex'
import OT from "@opentok/client";
import TroubleShooting from "@/components/flux360/LoginComponents/TroubleShooting";
import ConnectionTest from "@/components/flux360/LoginComponents/ConnectionTest";
import AudioTest from "@/components/flux360/LoginComponents/AudioTest";

//Icons
import Autorenew from 'vue-material-design-icons/Autorenew.vue'
import AlertCircle from 'vue-material-design-icons/MessageText.vue'
import CheckCircle from 'vue-material-design-icons/CheckCircle.vue'
import Wifi from 'vue-material-design-icons/Wifi.vue'

const publisherDefaultBackground = require("@/assets/black_background_for_publisher.png");

export default {
  inject: ['toggleCommunication'],
  components: {TroubleShooting,ConnectionTest,Autorenew,AlertCircle,CheckCircle,Wifi,AudioTest},
  data: () => ({
    videoOn: false,
    audioOn: false,
    videoDeviceList: [],
    audioDeviceList: [],
    movingAvg: null,
    ConnectionTestVisible: false,
    problemDialogVisible: false,
    audioTestDialogVisible: false,
    publisher: null,
    isLoading: true,
    publisherAndSubscriberProperties: {
      width: "100%",
      height: "100%",
      fitMode: "contain",
      frameRate: 30,
      insertDefaultUI: true,
      resolution: "320x240",
      showControls: false,
      style: {
        audioLevelDisplayMode: "off",
        buttonDisplayMode: "off",
        nameDisplayMode: "off",
        backgroundImageURI: publisherDefaultBackground,
      },
    },
    errors: {
      permissionDenied: false,
      microphonePermissionDenied: false,
      cameraPermissionDenied: false,
    },
  }),
  props: {
    toggleSettingsInLogin: Function,
    toggleLogin: Function,
    settingsVisible: Boolean,
    loginDialogueVisible: Boolean,
    from: String,
  },
  computed: {
    ...mapState({
      isOnboardingComplete: (state) => state.session.isOnboardingComplete,
    }),
    ...mapGetters(['getAudioDeviceId', 'getVideoDeviceId', 'isAudioOn', 'isVideoOn', 'localUser']),
    videoDeviceId() {
      return this.getVideoDeviceId;
    },
    audioDeviceId() {
      return this.getAudioDeviceId;
    },
    hasAudio() {
      if(this.publisher) return this.publisher.getAudioSource();
      return false;
    },
    hasVideo() {
      return this.publisher && this.publisher.videoHeight() > 0;
    },
  },
  watch: {
    videoDeviceId(newValue) {
      if (newValue && this.publisher) this.selectVideoDevice();
    },
    audioDeviceId(newValue) {
      if (newValue && this.publisher) this.handleAudioSelection();
    },
    videoOn(newValue) {
      this.$store.commit('setVideoOn', newValue);
    },
    audioOn(newValue) {
      this.$store.commit('setAudioOn', newValue);
      if (!newValue) {
        if (document.getElementById("local-user-badge")) {
          let badge = document.getElementById("local-user-badge");
          badge.style.transform = "scale(1,1)";
        }
        if (document.getElementById("audio-meter")) {
          let meter = document.getElementById("audio-meter");
          meter.value = 0;
        }
      }
    },
  },
  mounted() {
    const self = this;
    document.onkeydown = function (event) {
      if (event.key === 'Enter' && document.getElementById("audio-video-dialogue")) {
        self.saveDeviceIds();
        self.signIn();
      }
    }
    if (this.isAudioOn) {
      this.audioOn = this.isAudioOn;
    } else {
      this.$store.commit('setAudioOn', this.audioOn);
    }
    if (this.isVideoOn) {
      this.videoOn = this.isVideoOn;
    } else {
      this.$store.commit('setVideoOn', this.videoOn);
    }
    this.$root.$on('publisherCompleted', (publisher) => {
      self.publisher = publisher;
      self.addAudioLevelListenerForPublisher();
    });
    let element = document.createElement("div");
    element.style.display = "none";
    document.getElementsByTagName("body")[0].appendChild(element);
    this.askForPermission().then((result) => {
      if (!self.errors.microphonePermissionDenied) {
        self.audioOn = true;
        self.$store.commit('setAudioOn', this.audioOn);
      }
      if(!self.errors.cameraPermissionDenied) {
        self.videoOn = true;
        self.$store.commit('setVideoOn', this.videoOn);
      }
      setTimeout(function () {
        self.isLoading = false;
      }, 500);
    });
  },
  methods: {
    // setFramerate(){
    //   let frameSelection = document.getElementById("framerate-selection");
    //   if(frameSelection){
    //     this.$store.commit('setFramerate', Number(frameSelection.value));
    //   }
    // },
    // setBitrate(){
    //   let bitrateSelection = document.getElementById("bitrate-selection");
    //   if(bitrateSelection){
    //     this.$store.commit('setAudiobitrate', Number(bitrateSelection.value));
    //   }
    // },

    askForPermission: async function(){
      const self = this;
      return new Promise((resolve, reject) => {
        let element = document.createElement("div");
        element.style.display = "none";
        // initializing this publisher because Safari doesn't ask for permission if OT.getDevices() is called BEFORE OT.initPublisher()
        let pub = OT.initPublisher(element, {audioSource: true, videoSource: true}, function (error) {
          if(error){
            console.error(error);
            if (error.code === 1500 && error.name === "OT_USER_MEDIA_ACCESS_DENIED") {
              console.log("User denied permission");
              self.errors.permissionDenied = true;
              let pub2 = OT.initPublisher(element, {audioSource: true, videoSource: false}, function (error) {
                if (error) {
                  console.error("User denied microphone permission!");
                  self.errors.microphonePermissionDenied = true;
                }else{
                  pub2.destroy();
                  self.updateDeviceLists()
                      .then(function () {
                        self.restoreSelectionFromSessionStore()
                            .then(function () {
                              self.saveDeviceIds();
                            })
                      });
                }
              })
              let pub3 = OT.initPublisher(element, {audioSource: false, videoSource: true}, function (error) {
                if (error) {
                  console.error("User denied camera permission!");
                  self.errors.cameraPermissionDenied = true;
                  resolve(1);
                }else{
                  pub3.destroy();
                  self.updateDeviceLists()
                      .then(function () {
                        self.restoreSelectionFromSessionStore()
                            .then(function () {
                              self.saveDeviceIds();
                              resolve(1);
                            })
                      });
                }
              })
            }else{
              resolve(1);
            }
          }else{
            pub.destroy();
            self.updateDeviceLists()
                .then(function () {
                  self.restoreSelectionFromSessionStore()
                      .then(function () {
                        self.saveDeviceIds();
                        resolve(1);
                      })
                });
          }
        });
      });
    },
    getLabelForDevice(device){
      return device.label ? device.label : device.deviceId;
    },
    updateDeviceLists: async function () {
      return new Promise((resolve) => {
        OT.getDevices((error, devices) => {
          if(error) console.error(error);
          let videoDevices = devices.filter(device => device.kind === 'videoInput');
          let audioDevices = devices.filter(device => device.kind === 'audioInput');
          this.videoDeviceList = videoDevices;
          this.audioDeviceList = audioDevices;
          resolve();
        });
      });
    },
    handleAudioSelection() {
      this.saveDeviceIds();
      this.selectAudioDevice();
    },
    restoreSelectionFromSessionStore: async function () {
      const self = this;
      return new Promise((resolve) => {
        let videoSelect = document.getElementById("video-selection");
        let audioSelect = document.getElementById("audio-selection");
        if (this.getAudioDeviceId) {
          for (let a = 0; a < audioSelect.options.length; a++) {
            if (audioSelect.options[a].value === self.getAudioDeviceId) {
              audioSelect.selectedIndex = a;
              break;
            }
          }
        }
        if (this.getVideoDeviceId) {
          for (let a = 0; a < videoSelect.length; a++) {
            if (videoSelect.options[a].value === self.getVideoDeviceId) {
              videoSelect.selectedIndex = a;
              break;
            }
          }
        }
        resolve();
      })
    },
    saveDeviceIds: function () {
      let videoSelect = document.getElementById("video-selection");
      let audioSelect = document.getElementById("audio-selection");
      if (audioSelect.options[audioSelect.selectedIndex]) this.$store.commit("setAudioDeviceId", audioSelect.options[audioSelect.selectedIndex].value);
      if (videoSelect.options[videoSelect.selectedIndex]) this.$store.commit("setVideoDeviceId", videoSelect.options[videoSelect.selectedIndex].value);
    },
    signIn: function () {
      this.$root.$emit('updateAudioVideo');
      this.toggleLogin();
      this.toggleCommunication();
      this.toggleSettingsInLogin();
      this.$store.commit('setIsOnboardingComplete', true);
    },
    addAudioLevelListenerForPublisher() {
      const self = this;
      this.publisher.on('audioLevelUpdated', function (event) {
        if (self.movingAvg === null || self.movingAvg <= event.audioLevel) {
          self.movingAvg = event.audioLevel;
        } else {
          self.movingAvg = 0.7 * self.movingAvg + 0.3 * event.audioLevel;
        }

        if (self.audioOn) {
          // 1.5 scaling to map the -30 - 0 dBm range to [0,1]
          let logLevel = (Math.log(self.movingAvg) / Math.LN10) / 1.5 + 1;
          logLevel = Math.min(Math.max(logLevel, 0), 1) + 1;

          if (document.getElementById("local-user-badge")) {
            let badge = document.getElementById("local-user-badge")
            badge.style.transform = "scale(" + logLevel + ", " + logLevel + ")";
          }
          if (document.getElementById("audio-meter")) {
            let meter = document.getElementById("audio-meter");
            meter.value = logLevel - 1;
          }
        }

      });
    },
    getUserColor(user) {
      return ("#" + user.getColor().substring(2, 8));
    },
    selectVideoDevice() {
      const self = this;
      let maxCycles = this.videoDeviceList.length * 2;
      let count = 0;
      if (!self.isSelectingVideo) {
        cycle();
      }
      function cycle() {
        self.publisher.cycleVideo()
            .then(device => {
              self.$store.commit('setOpenTokSelectedVideoDevice', device);
              count++;
              if (self.getVideoDeviceId !== device.deviceId && count < maxCycles) {
                requestAnimationFrame(cycle);
              } else if (self.getVideoDeviceId === device.deviceId) {
                self.isSelectingVideo = false;
              }
            })
            .catch(e => {
              console.error(e);
            });
      }
    },
    selectAudioDevice() {
      const self = this;
      try {
        if (this.audioDeviceList.length > 0) {
          const device = this.audioDeviceList.filter(d => d.deviceId === this.getAudioDeviceId)[0];
          this.publisher.setAudioSource(device.deviceId)
              .then(() => {
                self.$store.commit('setOpenTokSelectedAudioDevice', device);
              })
              .catch(e => {
                console.error(e);
              });
        }
      } catch (e) {
        console.error(e);
      }
    },
    signOut: function () {
      const self = this;
      let logoff = null;
      if (this.localUser.getRole() === 'moderator') {
        logoff = this.$store.dispatch('logOffFromCms');
      } else {
        logoff = this.$store.dispatch('disconnectOpenTok');
      }
      this.$root.$emit('disconnectedOnPurpose');
      console.log(`Sign out for role ${this.role}`);
      logoff
          .then(() => {
            return this.$store.dispatch('initialize');
          })
          .then(() => {
            self.toggleSettingsInLogin();
            console.log('Signed out');
          })
          .catch((e) => {
            console.error(e);
          });
    },
    toggleConnectionTest() {
      this.ConnectionTestVisible = !this.ConnectionTestVisible;
    },
    toggleProblemDialog() {
      this.problemDialogVisible = !this.problemDialogVisible;
    },
    toggleAudioTestDialogue() {
      this.audioTestDialogVisible = !this.audioTestDialogVisible;
    }
  }
}
</script>

<style scoped>
#audio-video-dialogue {
  width: 100%;
  height: 100%; 
  display: flex;
  justify-content: center;
  align-items: center;
}
.avd-title {
  font-size: 30px;
  text-align: center;
  margin-bottom: 50px;
}
.avd-content-left{
  margin-right: 40px; 
  float: left;
}
.avd-content-right{
  float: right;
}
.subheading {
  font-size: 1.2em;
  margin-bottom: 20px;
}
.avd-switch{
  margin: 0;
  float: right;
}
.avd-switch-container{
  margin-bottom: 12px;
}
.avd-button-container{
  text-align: center;
}
.avd-audiotest{
  width: 100%;
}
.avd-login-button{
  font-size: 20px; 
  height: 45px; 
  width: 60%; 
  margin: 60px 0 20px 0 !important;
}
.avd-troubleshooting-button{
  height: 50px;
  width: 200px; 
  margin-right: 20px !important;
}
.avd-connectiontest-button{
  height: 50px; 
  width: 200px;
}
.avd-button-text{
  font-size: 12px !important;
}
.audio-video-loading-screen{
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 10;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
}


#audio-video-dialogue * {
  --md-theme-default-text-primary-on-background: #ffffff;
  --md-theme-default-icon-on-background: #ffffff;
}
.settings-section{
  background-color: #585858;
  margin-bottom: 40px;
  padding: 20px;
  width: 430px;
}
.settings-section:last-child{
  margin-bottom: 0;
}
.select-label{
  margin-bottom: 5px;
}
.slide-and-fade-enter-active, .slide-and-fade-leave-active {
  transition: all .3s ease;
}
.slide-and-fade-enter, .slide-and-fade-leave-to{
  opacity: 0;
  width: 0;
}
select {
  background: rgba(36, 36, 36, 0.4);
  color: white;
  margin-right: 5px;
  transition: none;
  width: calc(100% - 41px);
  height: 30px;
  border-radius: 3px;
  border: 0;
  box-shadow: none;
  padding: 2px 2px 2px 8px;
}

select:focus {
  padding: 0 0 0 6px;
  border: 2px solid var(--primaryColor);
  outline: none;
}

select:disabled {
  background: rgba(36, 36, 36, f0.4);
  color: rgb(138, 136, 136);
}

#audio-meter {
  margin-top: 10px;
  min-height: 10px;
  width: 100%;
}

#video-container {
  position: relative;
  height: 210px;
  width: 280px;
  margin-bottom: 10px;
  background: rgba(0, 0, 0, 0.658);
}

#publisher-container {
  position: absolute;
}

#publisher-container, #publisher-container * {
  min-width: 100%;
  min-height: 100%;
  max-height: 100%;
  max-width: 100%;
}

.camera-placeholder {
  position: relative;
  background-color: #262626;
  top: 50%;
}
.error-access-denied{
  font-size: 14px;
  color: #ff3737;
}
.error-access-denied-button{
  font-size: 16px;
  cursor: pointer;
  text-decoration: underline;
  color: #ff6e6e;
}
.error-access-denied-content{
  margin-bottom: 5px;
}
.error{
  margin-top: 5px;
}
.error-container {
  min-height: 20px;
  margin-bottom: 20px;
}

#audio-video-dialogue .md-switch{
  --md-theme-default-accent: var(--primaryColor);
  --md-theme-default-accent-on-: var(--secondaryColor);
  min-width: max-content;
}
.md-checkbox.md-theme-default.md-checked .md-checkbox-container:after {
  border-color: white !important;
  z-index: 2;
}
.md-checkbox.md-theme-default .md-checkbox-container{
  border-color: white;
}
.md-checkbox.md-theme-default.md-checked .md-checkbox-container:after {
  border-color: white !important;
  z-index: 2;
}

.badge {
  position: absolute;
  border-radius: 100%;
  top: calc(50% - 15px);
  left: calc(50% - 15px);
  height: 30px;
  max-height: 30px;
  width: 30px;
  min-width: 30px;
}
.user-badge {
  z-index: 6;
}
.user-badge-audio {
  opacity: 0.6;
  z-index: 5;
}

.renew {
  border-radius: 4px;
  height: 30px;
  min-width: 0;
  max-width: 30px;
  margin: 0;
}

.md-button{
  margin: 0;
  text-transform: none;
}
.md-button.md-theme-default[disabled]{
  background: #494949!important;
}
.md-button-content > div {
  font-size: 0.55rem;
  letter-spacing: 0.125em;
  text-transform: none;
}

.md-button .material-design-icon {
  font-size: 0.6rem;
}

#audio-video-dialogue .md-button {
  min-width: max-content;
}

#audio-video-dialogue .md-button * {
  display: flex;
  flex-direction: column;
  margin: 2px auto;
}
.avd-audiotest-loading{
  position: relative;
  width: 30px;
  height: 30px;
  margin: 0 auto 0 auto
}

.big-symbol-container {
  position: relative;
  width: 140px;
  height: 150px;
}
.avd-audiotest-icons{
  text-align: center;
}
.avd-audiotest-icons .alert-circle-icon, .avd-audiotest-icons .alert-circle-icon * {
  fill: rgb(190, 0, 0);
}
.alert-circle-icon{
  position: relative;
}
.check-circle-icon, .check-circle-icon * {
  fill: rgb(3, 112, 0);
}

.flux-animation-circle {
  position: absolute;
  background-color: var(--primaryColor);
  width: 12px;
  height: 12px;
  border-radius: 100%;
}

.flux-animation-circle-one {
  animation: fly-one 1.1s infinite ease-in-out;
  left: calc(100% - 4px);
  top: 33.3%;
}

.flux-animation-circle-two {
  animation: fly-two 1.1s infinite ease-in-out;
  left: 4px;
  top: 66.6%;
}

.flux-animation-circle-three {
  animation: fly-three 1.1s infinite ease-in-out;
  left: 4px;
  top: calc(33.3% - 2px);
}

@keyframes fly-one {
  0% {
    left: calc(100% - 4px);
    top: 33.3%;
  }
  18% {
    left: calc(50% - 2px);
    top: 4px;
  }
  40% {
    left: 4px;
    top: calc(33.3% - 2px);
  }
  49.9% {
    left: 4px;
    top: calc(66.6% - 2px);
  }
  66.6% {
    left: calc(50% - 2px);
    top: calc(100% - 2px);
  }
  81% {
    left: calc(100% - 4px);
    top: 66.6%;
  }
  100% {
    left: calc(100% - 4px);
    top: 33.3%;
  }
}

@keyframes fly-two {
  0% {
    left: calc(50% - 2px);
    top: 4px;
  }
  25% {
    left: 4px;
    top: calc(33.3% - 2px);
  }
  33.3% {
    left: 4px;
    top: calc(66.6% - 2px);
  }
  49.9% {
    left: calc(50% - 2px);
    top: calc(100% - 2px);
  }
  63% {
    left: calc(100% - 4px);
    top: 66.6%;
  }
  75% {
    left: calc(100% - 4px);
    top: 33.3%;
  }
  100% {
    left: calc(50% - 2px);
    top: 4px;
  }
}

@keyframes fly-three {
  0% {
    left: 4px;
    top: calc(33.3% - 2px);
  }
  16.6% {
    left: 4px;
    top: calc(66.6% - 2px);
  }
  33.3% {
    left: calc(50% - 2px);
    top: calc(100% - 2px);
  }
  45% {
    left: calc(100% - 4px);
    top: 66.6%;
  }
  57% {
    left: calc(100% - 4px);
    top: 33.3%;
  }
  74% {
    left: calc(50% - 2px);
    top: 4px;
  }
  100% {
    left: 4px;
    top: calc(33.3% - 2px);
  }
}

/* Mobile */
@media screen and (max-width: 900px) {
  #audio-video-dialogue{
    align-items: initial;
  }
  .audio-video-content{
    width: 90%;
  }
  .avd-title{
    margin-bottom: 10px;
    margin-top: 10px;
  }
  .avd-content-left{
    margin-right: 0; 
    float: initial;
    text-align: center;
  }
  .avd-content-right{
    float: initial;
  }
  .avd-audiotest{
    width: 260px;
  }
  .avd-login-button{
    font-size: 18px; 
    height: 50px; 
    width: 90%; 
    margin: 20px 0 10px 0 !important;
  }
  .avd-troubleshooting-button{
    height: 50px;
    width: 80px; 
    margin-right: 20px !important;
  }
  .avd-connectiontest-button{
    height: 50px; 
    width: 80px; 
  }
  .avd-button-text{
    font-size: 10px !important;;
  }
  .avd-audiotest{
    margin-bottom: 20px;
  }
  .settings-section{
    width: 100%;
  }
  #video-container {
    margin: 0 auto 20px auto;
  }
  .error-access-denied{
    margin: 0 auto;
    margin-bottom: 5px;
  }

}
</style>